import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { generateFax, generateInvoice, downloadExcel, dealerSalesReport, getFinancialYear, dealersCombinedReport, downloadCombinedExcel } from "@/api/orders-dispatches";
import Pagination from "@/components/Pagination/index.vue";
import { getQuery } from "@/utils/index";
import Inr from "@/components/Inr/index.vue";
import { getAdmins } from "@/api/admins";
import { getAgentById } from "@/api/agents";
import { getAgentDealers, getDealerCities, searchDealers } from "@/api/dealers";
import { AdminModule } from "@/store/modules/admin";
import { getStates } from "@/api/locations/states";
import { getCities } from "@/api/locations/cities";
import Enabled from "@/components/Enabled/index.vue";
import { BranchAgentService } from "@/services/branch-agent-service";
import { cleanListQuery, isAdmin, isSalesExecutiveManager, isSuperAdmin, isZonalManager } from "@/common";
import moment from "moment";
import { SALES_EXECUTIVE, ZONAL_MANAGER } from "@/constants/roles.constants";
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.baseUrl = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.dateRange = "";
    this.branchListLoading = false;
    this.branchList = [];
    this.dialogVisible = false;
    this.isAgent = false;
    this.dispatchId = 0;
    this.agentList = [];
    this.agentUserList = [];
    this.dealerList = [];
    this.stateList = [];
    this.cityList = [];
    this.dealerListLoading = false;
    this.stateListLoading = false;
    this.cityListLoading = false;
    this.totalGrandTotal = "";
    this.assignedBranches = [] || null;
    this.salesExecutiveAdmins = [];
    this.zonalManagerAdmins = [];
    this.selectedColumns = [];
    this.showId = false;
    this.showDealerCode = false;
    this.showDealerCity = false;
    this.showDealerState = false;
    this.showSalesExecutiveAdmin = false;
    this.showSalesExecutiveAgent = false;
    this.showZonalManager = false;
    this.showFilters = false;
    this.seeCombinedReport = false;
    this.grandTotalSales = "";
    this.grandTotalPayments = "";
    this.grandTotalImpactValue = "";
    this.statusColorMap = {
      Pending: "warning",
      "Request Approval": "primary",
      Approved: "success",
      Rejected: "danger"
    };
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      adminId: undefined,
      agentId: undefined,
      agentUserId: undefined,
      stateId: undefined,
      cityName: undefined,
      startDate: undefined,
      endDate: undefined,
      applyBranchIdFilter: true,
      excludeBranches: false,
      "assignedAgents.id": undefined,
      "['mappedAdmin.id']": undefined,
      "['zonalAdmin.id']": undefined,
      branchId: [],
      sort: "id,ASC",
      filter: {
        dealerId: "$eq",
        adminId: "$eq",
        agentId: "$eq",
        agentUserId: "$eq",
        stateId: "$eq",
        cityName: "$eq",
        branchId: "$in",
        "assignedAgents.id": "$eq",
        "mappedAdmin.id": "$eq",
        "zonalAdmin.id": "$eq"
      }
    };
    this.sortOptions = [{
      label: "ID Ascending",
      key: "id,ASC"
    }, {
      label: "ID Descending",
      key: "id,DESC"
    }];
    this.columnOptions = [{
      label: "ID",
      key: "ID"
    }, {
      label: "Dealer Code",
      key: "Dealer Code"
    }, {
      label: "City",
      key: "City"
    }, {
      label: "State",
      key: "State"
    }, {
      label: "Sales Executive Agent",
      key: "Sales Executive Agent"
    }, {
      label: "Sales Executive Admin",
      key: "Sales Executive Admin"
    }, {
      label: "Zonal Manager",
      key: "Zonal Manager"
    }];
    this.combinedOptions = [{
      label: "Yes",
      key: true
    }, {
      label: "No",
      key: false
    }];
    this.loggedInAdmin = null;
    this.shortcuts = [{
      key: "thisWeek",
      label: "This week",
      value: "isoWeek"
    }, {
      key: "lastWeek",
      label: "Last week",
      value: "-isoWeek"
    }, {
      key: "last7Days",
      label: "Last 7 days",
      value: 7
    }, {
      key: "last30Days",
      label: "Last 30 days",
      value: 30
    }, {
      key: "thisMonth",
      label: "This month",
      value: "month"
    }, {
      key: "lastMonth",
      label: "Last month",
      value: "-month"
    }, {
      key: "thisYear",
      label: "This FY",
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, "days");
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: "lastYear",
      label: "Last FY",
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, "days");
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
    this.getAdminByRole = (mappedAdmins, roleName) => {
      try {
        if (!mappedAdmins || !Array.isArray(mappedAdmins)) return "N/A";
        // Find admin with the specified role
        const admin = mappedAdmins.find(admin => {
          var _admin$roles;
          return admin === null || admin === void 0 || (_admin$roles = admin.roles) === null || _admin$roles === void 0 ? void 0 : _admin$roles.some(role => (role === null || role === void 0 ? void 0 : role.name) === roleName);
        });
        return admin ? admin.fullName : "N/A";
      } catch (err) {
        console.error(`Error processing ${roleName} admin:`, err);
        return "Error";
      }
    };
  }
  isSalesExecutiveAdmin() {
    return isSalesExecutiveManager();
  }
  isZonalManagerAdmin() {
    return isZonalManager();
  }
  onCheckboxChange(value) {
    this.listQuery.excludeBranches = value;
  }
  _isAdminRoles() {
    return isSuperAdmin() || isAdmin();
  }
  async fetchSalesExecutiveManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [SALES_EXECUTIVE],
      filter: {
        enabled: "$eq",
        adminsRoleId: "$in"
      }
    }));
    this.salesExecutiveAdmins = allManagers.data;
  }
  async fetchZonalAdminManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [ZONAL_MANAGER],
      filter: {
        enabled: "$eq",
        adminsRoleId: "$in"
      }
    }));
    this.zonalManagerAdmins = allManagers.data;
  }
  async activated() {
    try {
      // if (!this._isAdminRoles()) {
      this.listQuery.excludeBranches = true;
      // }
      // Assign branchId using BranchAgentService
      // this.listQuery.branchId = await BranchAgentService.assignBranchId();
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error("You are not assigned to a branch.");
      }
      // Fetch agents for the assigned branchId
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      this.loggedInAdmin = AdminModule;
      // check if logged in user is Agent/Admin
      if (this.loggedInAdmin.userType === "Agent") {
        this.isAgent = true;
        this.listQuery.agentId = this.loggedInAdmin.agentId;
        this.listQuery.agentUserId = this.loggedInAdmin.id;
        if (this.loggedInAdmin.roles.includes("Owner")) {
          this.listQuery.agentUserId = null;
        }
      }
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.dateRange = {
          start: this.$route.query.startDate,
          end: this.$route.query.endDate
        };
      }
      if (!this.dateRange) {
        await this.getCurrentFinancialYear();
      }
      this.listQuery = {
        ...this.listQuery,
        ...this.$route.query
      };
      this.fetchSalesExecutiveManagers();
      this.fetchZonalAdminManagers();
      // get dispatch list
      this.getList();
      this.getStateList();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: "Error",
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  handleCombinedSelection() {
    this.getList();
  }
  async getList() {
    try {
      let data = null;
      this.listQuery = cleanListQuery(this.listQuery);
      if (this.dateRange) {
        this.listQuery.startDate = this.dateRange.start;
        this.listQuery.endDate = this.dateRange.end;
      }
      if (!this.seeCombinedReport) {
        data = await dealerSalesReport(this.listQuery);
        this.totalGrandTotal = data.sum;
        this.grandTotalPayments = null;
        this.grandTotalImpactValue = data.totalImpactValue; // ADD
      } else {
        data = await dealersCombinedReport(this.listQuery);
        this.totalGrandTotal = data.grandTotalSales;
        this.grandTotalPayments = data.grandTotalPayments;
        this.grandTotalImpactValue = null; // ADD
      }
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getCurrentFinancialYear() {
    const dateData = await getFinancialYear();
    this.dateRange = {
      start: dateData.startDate,
      end: dateData.endDate
    };
    this.listQuery.startDate = this.dateRange.start;
    this.listQuery.endDate - this.dateRange.end;
    // this.getList();
  }
  async downloadFax() {
    this.listLoading = true;
    try {
      const params = {};
      if (this.listQuery.adminId) {
        params.adminId = this.listQuery.adminId;
      }
      if (this.listQuery.agentId) {
        params.agentId = this.listQuery.agentId;
      }
      if (this.listQuery.dealerId) {
        params.dealerId = this.listQuery.dealerId;
      }
      if (this.listQuery.status) {
        params.status = this.listQuery.status;
      }
      if (this.dateRange) {
        params.startDate = this.dateRange.start;
        params.endDate = this.dateRange.end;
      }
      if (Object.keys(params).length) {
        const data = await generateFax(getQuery(params));
        window.open(data.url, "_blank");
        // const filename: string = "fax_" + new Date().getTime() + ".pdf";
        // this.downloadFile(data.url, filename);
      } else {
        this.$message({
          message: "Please select atleast one filter",
          type: "warning"
        });
      }
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? "dealerId" : "name",
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getStateList(query = null) {
    try {
      this.stateList = await getStates(getQuery({
        enabled: true,
        sort: "name,ASC",
        filter: {
          enabled: "eq"
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(stateId = 0) {
    try {
      this.cityListLoading = true;
      this.cityList = await getCities(getQuery({
        enabled: true,
        stateId,
        sort: "name,ASC",
        filter: {
          enabled: "$eq",
          stateId: "$eq"
        }
      }));
      this.cityListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getDealerCityList(params) {
    const data = await getDealerCities(params);
    this.stateList = data.stateList;
    this.cityList = data.cityList;
  }
  async getAgentDealersList(params) {
    const data = await getAgentDealers(params);
    // const data: any = await getAgentRoleWiseDealer(params);
    this.dealerList = data;
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    } else {
      this.listQuery.startDate = undefined;
      this.listQuery.endDate = undefined;
    }
    if (this.listQuery.stateId) {
      this.showDealerState = true;
      this.showDealerCity = true;
      this.getCityList(this.listQuery.stateId);
    } else {
      // empty city
      this.showDealerState = false;
      this.showDealerCity = false;
      this.cityList = [];
      this.listQuery.cityId = undefined;
      this.listQuery.stateId = undefined;
    }
    if (!this.listQuery.cityId) {
      this.listQuery.cityId = undefined;
    }
    if (this.listQuery.dealerId) {
      const params = {
        dealerId: undefined
      };
      params.dealerId = this.listQuery.dealerId;
      this.getDealerCityList(params);
    }
    if (this.listQuery.agentId) {
      const params = {
        agentId: undefined
      };
      params.agentId = this.listQuery.agentId;
      // params.roles = AdminModule.roles;
      // this.getAgentDealersList(params);
    }
    if (this.listQuery.agentId) {
      const agentData = await getAgentById(this.listQuery.agentId);
      this.agentUserList = agentData.agentUser.filter(user => user.roles.some(role => role.name === "Sales Executive"));
    }
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop}` + (order === "ascending" ? ",ASC" : ",DESC");
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? "ascending" : sort === `${key},DESC` ? "descending" : "";
  }
  toggleDialog(id = 0) {
    this.dialogVisible = true;
    this.dispatchId = id;
  }
  async downloadInvoice(id = 0) {
    // get invoice url
    this.listLoading = true;
    const url = await generateInvoice(id);
    if (url) {
      window.open(url, "_blank");
      // const filename = "invoice_" + id + ".pdf";
      // this.downloadFile(data.url, filename);
    } else {
      this.$message({
        message: "Failed to generate invoice",
        type: "error"
      });
    }
    this.listLoading = false;
  }
  async handleCombinedExcelDownload() {
    this.downloadLoading = false;
    try {
      const blob = await downloadCombinedExcel(this.listQuery);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "combined-report.xlsx");
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel:", error);
      this.$message.error("Error downloading Excel");
    }
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    this.listQuery = cleanListQuery(this.listQuery);
    try {
      const queryWithoutPagination = {
        ...this.listQuery
      };
      delete queryWithoutPagination.page;
      delete queryWithoutPagination.limit;
      const allDataResponse = await dealerSalesReport(queryWithoutPagination);
      let startDate;
      let endDate;
      if (this.listQuery.startDate && this.listQuery.endDate) {
        startDate = this.listQuery.startDate;
        endDate = this.listQuery.endDate;
      }
      const allData = allDataResponse.data;
      let grandTotal = allData.reduce((total, item) => total + +item.totalAmount, 0);
      if (grandTotal) {
        grandTotal = grandTotal.toFixed(2);
      } else {
        grandTotal = 0;
      }
      const query = this.listQuery;
      const blob = await downloadExcel({
        query,
        grandTotal,
        startDate,
        endDate,
        applyBranchIdFilter: true
      });
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "sales-report.xlsx");
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel:", error);
      this.$message.error("Error downloading Excel");
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    const totalGrandTotalRow = [];
    columns.forEach((column, index) => {
      // first column
      if (index === 0) {
        sums[index] = "Total Page Sales: ";
        totalGrandTotalRow[index] = "Grand Total: "; // Add label for the total grand total row
        return;
      }
      // Grand Total column
      if (index === 9) {
        // get all values
        const values = data.map(item => Number(item[column.property]));
        // loop over & null check
        if (!values.every(value => isNaN(value))) {
          // sum them using reduce
          sums[index] = values.reduce((prev, curr) => {
            // value conversion (do check with Sandesh if toFixed something else required for decimal precision)
            const value = Number(curr);
            // null check
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0); // initial value
          // Calculate total grand total
          if (this.totalGrandTotal) {
            totalGrandTotalRow[index] = parseFloat(this.totalGrandTotal).toFixed(2);
          } else {
            totalGrandTotalRow[index] = 0;
          } // Store the totalGrandTotal value
        } // loop if ends
      } // index check ends
    }); // column loop ends
    // Return sums and total grand total row
    if (sums && sums.length) {
      if (sums[9]) {
        sums[9] = sums[9].toFixed(2);
      } else {
        sums[9] = 0;
      }
      //
    }
    return [,,,,,,,,, sums, totalGrandTotalRow]; // Return both the sums and total grand total row
  }
  handleVisibleColumns(data) {
    this.showId = data.includes("ID");
    this.showDealerCode = data.includes("Dealer Code");
    this.showDealerCity = data.includes("City");
    this.showDealerState = data.includes("State");
    this.showSalesExecutiveAgent = data.includes("Sales Executive Agent");
    this.showSalesExecutiveAdmin = data.includes("Sales Executive Admin");
    this.showZonalManager = data.includes("Zonal Manager");
  }
  get pageTotalSales() {
    if (!this.list || !this.list.length) return 0;
    if (this.seeCombinedReport) {
      return this.list.reduce((sum, item) => sum + +(item.totalsales || 0), 0);
    }
    return this.list.reduce((sum, item) => sum + +(item.totalAmount || 0), 0);
  }
  get pageTotalPayments() {
    if (!this.list || !this.list.length || !this.seeCombinedReport) return 0;
    return this.list.reduce((sum, item) => sum + Number(item.totalpayments || 0), 0);
  }
  get pageTotalImpactValue() {
    if (!this.list || !this.list.length || this.seeCombinedReport) return 0;
    return this.list.reduce((sum, item) => sum + Number(item.totalImpactValue || 0), 0);
  }
};
default_1 = __decorate([Component({
  name: "SalesReportList",
  components: {
    Pagination,
    Inr,
    Enabled
  }
})], default_1);
export default default_1;